// extracted by mini-css-extract-plugin
export default {"paper1":"timepicker_paper1__zp89w","paper2":"timepicker_paper2__reFZ8"};